import * as React from "react";
const SvgFiRrCandleHolder = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-candle-holder_svg__a)">
      <path
        fill="#062147"
        d="M20 16c-.986 0-1.933.362-2.667 1.019a1 1 0 1 0 1.334 1.49A2.002 2.002 0 0 1 22 20c0 1.103-.897 2-2 2h-6v-9.5C14 10.019 11.981 8 9.5 8h-3A4.505 4.505 0 0 0 2 12.5V22H1a1 1 0 0 0 0 2h19c2.206 0 4-1.794 4-4s-1.794-4-4-4M4 12.5C4 11.122 5.122 10 6.5 10h3c1.378 0 2.5 1.122 2.5 2.5V22H4zm1.709-8.791c0-.731.766-2.148 1.412-3.214.4-.66 1.358-.66 1.758 0 .646 1.065 1.412 2.482 1.412 3.214a2.291 2.291 0 0 1-4.582 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-candle-holder_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCandleHolder;
